import axios from "axios"

export const apiInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BASE_URl,
  // timeout: 5000,
  // withCredentials: true,
})
